import React from "react";
import { ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HersBinsServices() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="39517" id="the-music-experience" className="relative h-screen w-full overflow-hidden bg-[#1A1A1A]">
      {}
      <img src="https://zemayohannes.com/wp-content/uploads/2026/05/FB_IMG_1778081473074.jpg" alt="Zema Yohannes Worship" className="absolute inset-0 h-full w-full object-cover" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />

      {}
      <div className="relative z-10 flex h-full max-w-7xl flex-col justify-center px-8 mx-auto">
        <div ref={contentRef} className={`flex flex-col transition-all duration-[2500ms] ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className={`p-8 md:p-12 bg-black/30 backdrop-blur-[2px] rounded-md transition-all duration-[2500ms] ease-out transform ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            <h1 className="font-serif text-5xl font-bold leading-tight text-white md:text-[72px] drop-shadow-lg">
              Zema <span className="text-[#FF6A00]">Yohannes</span>
            </h1>

            <p className="mt-0 max-w-[600px] font-sans text-lg leading-[1.5] text-[#E5E5E5] md:text-[48px] drop-shadow-md">
              <span className="text-white">Worship Ministry</span>
            </p>

            <p className="mt-6 max-w-[600px] font-sans text-lg leading-[1.5] text-[#E5E5E5] md:text-[22px]">
              Advance Gospel worship ministry nationwide by nurturing young, talented gospel singers and empowering the Christian community to worship with spirit, truth, and excellence.
            </p>

            {}
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Button asChild className="h-[60px] w-full rounded-md bg-gradient-to-r from-[#FF6A00] to-[#FF5C00] text-lg font-semibold text-white shadow-lg shadow-[#FF6A00]/20 transition-transform hover:scale-105 hover:opacity-90 sm:w-[240px]">
                <Link to="https://www.youtube.com/@yohanneswakgariofficialcha6717" target="_blank" rel="noopener noreferrer" aria-label="Visit Zema Yohannes YouTube channel">
                  <Search className="mr-2 h-5 w-5" />
                  Visit YouTube
                </Link>
              </Button>

              <Button asChild variant="outline" className="h-[60px] w-full rounded-md border-[#FF6A00] bg-transparent text-lg font-semibold text-[#FF6A00] transition-colors hover:bg-[#FF6A00]/10 hover:text-[#FF6A00] sm:w-[240px]">
                <Link to="https://www.youtube.com/watch?v=APs0ukHrwvA&list=PLcdWRTAViBAwM0s0JFpqPJZomPZ3Bugwl" target="_blank" rel="noopener noreferrer" aria-label="Listen to Zema Yohannes music">
                  Listen Now
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2">
        <span className="text-xs font-medium uppercase tracking-widest text-[#FF6A00]">
          Scroll
        </span>
        <div className="h-16 w-[1px] overflow-hidden bg-white/20">
          <div className="h-1/2 w-full animate-pulse bg-[#FF6A00]" />
        </div>
      </div>
    </section>;
}